import React from "react";
import Typography from "@material-ui/core/Typography";

const AboutUs = () => (
  <div>
    <Typography variant="h6" color="inherit" gutterBottom>
      Nosotros
    </Typography>
    <Typography variant="body2" color="inherit" paragraph>
      Dashport empezó con la firme convicción de que podíamos integrar la tecnología y el
      deporte, con el fin de que cada vez mas personas realicen actividades físicas.
    </Typography>
    <Typography variant="body2" color="inherit" paragraph>
      Actualmente nos dedicamos a eso, desarrollamos herramientas tecnológicas que,
      de una u otra manera, están contribuyendo a aumentar la cantidad de personas que
      practican actividades físicas de forma habitual.
    </Typography>
  </div>
);

export default AboutUs;
